import * as TYPE from './actionType.js';

export function dropTrailerData(dropTrailerData) {
  return { type: TYPE.DROPTRAILERDATA, data: dropTrailerData };
}
